<button
  mat-menu-item
  [ngClass]="template.viewed ? null : 'pristine'"
  [routerLink]="template.routerLink || []"
  [queryParams]="{source: 'schedule'}"
>
  <h6>{{ template.name }}</h6>
  <p>Scheduled By: {{ template.owner }}</p>
</button>
